<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";
import {easepick} from '@easepick/core';

export default {
  mixins: [formInput],
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    }
  },

  methods: {
    initialiseEasepick() {
      let $input = $(this.$refs.input);
      let datepicker = new easepick.create({
        element: this.$refs.input,
        css: [
          '/css/easepick.css',
        ],
        zIndex: 10,
        format: 'YYYY-MM-DD',
        lang: 'nl-NL',
      });

      $input.data('datepicker', datepicker);
      datepicker.on('select', () => this.changeModelValue($input.val()));
      this.$watch('modelValue', value => datepicker.setDate(value));
    },

    changeModelValue(value) {
      if(this.form) {
        delete this.form.errors[this.name];
      }
      this.$emit('update:modelValue', value);
    }
  },

  mounted() {
    this.initialiseEasepick();
  }
}
</script>

<template>
    <input
        ref="input"
        :name="name"
        v-bind="$attrs"
        type="date"
        :id="renderedId"
        :class="{'form-control': true, 'border-danger': hasError}"
        :value="modelValue"
    >
    <label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
</template>